import React from 'react';
import { BooleanSettings } from 'modules/settingsContainer/common/BooleanSettings';
import { BooleanSettingsControlInterface } from 'modules/settingsContainer/common/BooleanSettings/types';

type NameFromDatabaseSettingsProps = Required<BooleanSettingsControlInterface>;

export const NameFromDatabaseSettings = ({ value, onChange }: NameFromDatabaseSettingsProps) => {
  return <BooleanSettings titleText="Название из источника" value={value} onChange={onChange} />;
};
